// extracted by mini-css-extract-plugin
export default {"marginTop":"DefaultReduxLoadingError_marginTop__VW1m1","errorBox":"DefaultReduxLoadingError_errorBox__r2ibz","link":"DefaultReduxLoadingError_link__-6khw"};